import React, { memo, type MutableRefObject } from 'react';

import { AgenticEditorBannerLoader } from '@confluence/editor-action-bar/entry-points/AgenticEditorBannerLoader.ts';
import { SmartCreateFeedbackBannerLoader } from '@confluence/editor-action-bar/entry-points/SmartCreateFeedbackBannerLoader.ts';

type BaseProps = {
	isLivePage: boolean;
	spaceKey: string;
};

export type FullPageEditorBannerWrapperProps = BaseProps & {
	isAgenticMode: boolean;
	onExitAgenticMode: () => void;
	onDismissAgenticMode: () => void;
	agenticModeStartTime?: number;
	// Pass refs (not values) so the banner reads live counts at submit time.
	aiInvocationCountRef?: MutableRefObject<number>;
	aiInvocationSurfacesRef?: MutableRefObject<Record<string, number>>;
};

const StandardBannerWrapper = ({ isLivePage, spaceKey }: BaseProps) => {
	if (spaceKey !== 'XFLOW' && !isLivePage) {
		return <SmartCreateFeedbackBannerLoader contentType="page" />;
	}

	return null;
};

export const FullPageEditorBannerWrapper: React.MemoExoticComponent<
	({
		isAgenticMode,
		onExitAgenticMode,
		onDismissAgenticMode,
		agenticModeStartTime,
		aiInvocationCountRef,
		aiInvocationSurfacesRef,
		isLivePage,
		spaceKey,
	}: FullPageEditorBannerWrapperProps) => React.JSX.Element
> = memo(
	({
		isAgenticMode,
		onExitAgenticMode,
		onDismissAgenticMode,
		agenticModeStartTime,
		aiInvocationCountRef,
		aiInvocationSurfacesRef,
		isLivePage,
		spaceKey,
	}: FullPageEditorBannerWrapperProps): React.JSX.Element => {
		if (isAgenticMode) {
			return (
				<AgenticEditorBannerLoader
					onExitAgenticMode={onExitAgenticMode}
					onDismiss={onDismissAgenticMode}
					agenticModeStartTime={agenticModeStartTime}
					aiInvocationCountRef={aiInvocationCountRef}
					aiInvocationSurfacesRef={aiInvocationSurfacesRef}
				/>
			);
		}

		return <StandardBannerWrapper isLivePage={isLivePage} spaceKey={spaceKey} />;
	},
);
